export enum BankAccounts {
  GweClient = 0,
}
